export default class WorkplanEvaluationCtrl {
  constructor ($scope, $stateParams, $timeout, WorkPlanSrv, WorkPlanModalSrv, GlobalConfig, $cookies, $state, ReviewSrv, $rootScope, uiGridConstants,uiGridExporterConstants, $interval, $mdDialog) {
  // Constants
    const workplanEvaluationVM = this
    const stagesIds = GlobalConfig.workplanIdStages
    const evaluationIndicatorIds = {
      evaluated: 5,
      forEvaluating: 6,
      specialSituations:7,
      withAdjustments: 8,
    }
    $rootScope.fullscreenClass = 'background-planning';
    
    // Grid definition
    workplanEvaluationVM.gridOptionsSpecialSituations = {
      columnDefs: [
        {
          name: 'Nombre del profesor',
          displayName: 'Nombre del profesor',
          field: 'teacherName',
          width: '30%',
          enableGridMenu: false,
          enableFiltering: false,
          enableHiding: false,
          enablePinning: false,
          enableColumnMenu: false,
          enableSorting: false
        }, {
          name: 'Nota',
          displayName: 'Nota',
          field: 'ds_description',
          width: '50%',
          enableGridMenu: false,
          enableFiltering: false,
          enableHiding: false,
          enablePinning: false,
          enableColumnMenu: false,
          enableSorting: false
        }, {
          name: 'Acciones',
          displayName: 'Acciones',
          field: 'actionText',
          width: '18%',
          enableGridMenu: false,
          enableFiltering: false,
          enableHiding: false,
          enablePinning: false,
          enableColumnMenu: false,
          enableSorting: false,
          headerCellClass: 'column-center',
          cellTemplate: '<panel-router-evaluation data="{teacherId: row.entity.teacherId, workplanId: row.entity.workplanId, name: row.entity.teacherName}" action="row.entity.actionText"></panel-router-evaluation>'
        }
      ],
      onRegisterApi: (gridApi) => {
        workplanEvaluationVM.gridApi = gridApi;
        workplanEvaluationVM.gridApi.grid.registerRowsProcessor(workplanEvaluationVM.singleFilter, 200);
        $interval(function () {
          workplanEvaluationVM.gridApi.core.handleWindowResize()
        }, 500, 10)
      }
    }
    workplanEvaluationVM.gridOptionsEvaluated = {
      columnDefs: [
        {
          name: 'Nombre del profesor',
          displayName: 'Nombre del profesor',
          field: 'teacherName',
          width: '30%',
          enableGridMenu: false,
          enableFiltering: false,
          enableHiding: false,
          enablePinning: false,
          enableColumnMenu: false,
          enableSorting: false
        }, {
          name: 'Calificación',
          displayName: 'Calificación',
          field: 'nm_rating',
          width: '40%',
          enableGridMenu: false,
          enableFiltering: false,
          enableHiding: false,
          enablePinning: false,
          enableColumnMenu: false,
          enableSorting: false
        }, {
          name: 'Acciones',
          displayName: 'Acciones',
          field: 'actionText',
          width: '25%',
          enableGridMenu: false,
          enableFiltering: false,
          enableHiding: false,
          enablePinning: false,
          enableColumnMenu: false,
          enableSorting: false,
          headerCellClass: 'column-center',
          cellTemplate: '<panel-router-evaluation data="{teacherId: row.entity.teacherId, workplanId: row.entity.workplanId, name: row.entity.teacherName}" action="row.entity.actionText"></panel-router-evaluation>'
        }
      ],
      onRegisterApi: (gridApi) => {
        workplanEvaluationVM.gridApi = gridApi;
        workplanEvaluationVM.gridApi.grid.registerRowsProcessor(workplanEvaluationVM.singleFilter, 200);
        $interval(function () {
          workplanEvaluationVM.gridApi.core.handleWindowResize()
        }, 500, 10)
      }
    }
    workplanEvaluationVM.gridOptionsAdjustments = {
      columnDefs: [
        {
          name: 'Nombre del profesor',
          displayName: 'Nombre del profesor',
          field: 'teacherName',
          width: '60%',
          enableGridMenu: false,
          enableFiltering: false,
          enableHiding: false,
          enablePinning: false,
          enableColumnMenu: false,
          enableSorting: false
        }, {
          name: 'Acciones',
          displayName: 'Acciones',
          field: 'actionText',
          width: '15%',
          enableGridMenu: false,
          enableFiltering: false,
          enableHiding: false,
          enablePinning: false,
          enableColumnMenu: false,
          enableSorting: false,
          headerCellClass: 'column-center',
          cellTemplate: '<panel-router-evaluation data="{teacherId: row.entity.teacherId, workplanId: row.entity.workplanId, name: row.entity.teacherName}" action="row.entity.actionText"></panel-router-evaluation>'
        }
      ],
      onRegisterApi: (gridApi) => {
        workplanEvaluationVM.gridApi = gridApi;
        workplanEvaluationVM.gridApi.grid.registerRowsProcessor(workplanEvaluationVM.singleFilter, 200);
        $interval(function () {
          workplanEvaluationVM.gridApi.core.handleWindowResize();
          
        }, 500, 10)
      }
    }
    workplanEvaluationVM.gridOptionsForEvaluating = {
      columnDefs: [
        {
          name: 'Nombre del profesor',
          displayName: 'Nombre del profesor',
          field: 'teacherName',
          width: '30%',
          enableGridMenu: false,
          enableFiltering: false,
          enableHiding: false,
          enablePinning: false,
          enableColumnMenu: false,
          enableSorting: false
        }, {
          name: 'Horas Planeadas',
          displayName: 'H/Planeadas',
          field: 'nm_plannedHours',
          width: '13%',
          enableGridMenu: false,
          enableFiltering: false,
          enableHiding: false,
          enablePinning: false,
          enableColumnMenu: false,
          enableSorting: false
        }, {
          name: 'Horas Ejecutadas',
          displayName: 'H/Ejecutadas',
          field: 'nm_workedHours',
          width: '13%',
          enableGridMenu: false,
          enableFiltering: false,
          enableHiding: false,
          enablePinning: false,
          enableColumnMenu: false,
          enableSorting: false
        }, {
          name: 'Actividades Planeadas',
          displayName: 'Act/Planeadas',
          field: 'nm_plannedActivities',
          width: '13%',
          enableGridMenu: false,
          enableFiltering: false,
          enableHiding: false,
          enablePinning: false,
          enableColumnMenu: false,
          enableSorting: false
        },  {
          name: 'Actividades Ejecutadas',
          displayName: 'Act/Ejecutadas',
          field: 'nm_workedActivities',
          width: '13%',
          enableGridMenu: false,
          enableFiltering: false,
          enableHiding: false,
          enablePinning: false,
          enableColumnMenu: false,
          enableSorting: false
        }, {
          name: 'Acciones',
          displayName: 'Acciones',
          field: 'actionText',
          width: '14%',
          enableGridMenu: false,
          enableFiltering: false,
          enableHiding: false,
          enablePinning: false,
          enableColumnMenu: false,
          enableSorting: false,
          headerCellClass: 'column-center',
          cellTemplate: '<panel-router-evaluation data="{teacherId: row.entity.teacherId, workplanId: row.entity.workplanId, name: row.entity.teacherName}" action="row.entity.actionText"></panel-router-evaluation>'
        }
      ],
      onRegisterApi: (gridApi) => {
        workplanEvaluationVM.gridApi = gridApi;
        workplanEvaluationVM.gridApi.grid.registerRowsProcessor(workplanEvaluationVM.singleFilter, 200);
        $interval(function () {
          workplanEvaluationVM.gridApi.core.handleWindowResize();  
        }, 500, 10)
      }
    }
    workplanEvaluationVM.gridOptionsDefault = {
      columnDefs: [
        {
          name: 'Nombre profesor',
          displayName: 'Nombre profesor',
          field: 'teacherName',
          width: '25%',
          enableGridMenu: false,
          enableHiding: false,
          enablePinning: false,
          enableColumnMenu: false,
          enableSorting: false
        }, {
          name: 'Plan de trabajo asignado',
          displayName: 'Plan de trabajo asignado',
          field: 'workplanName',
          width: '30%',
          enableGridMenu: false,
          enableHiding: false,
          enablePinning: false,
          enableColumnMenu: false,
          enableSorting: false
        }, {
          name: 'Estado',
          displayName: 'Estado',
          field: 'stageName',
          width: '30%',
          enableGridMenu: false,
          enableHiding: false,
          enablePinning: false,
          enableColumnMenu: false,
          enableSorting: false
        }, {
          name: 'Acciones',
          displayName: 'Acciones',
          field: 'actionText',
          width: '15%',
          enableGridMenu: false,
          enableHiding: false,
          enablePinning: false,
          enableColumnMenu: false,
          enableSorting: false,
          headerCellClass: 'column-center',
          cellTemplate: '<panel-router-evaluation data="{teacherId: row.entity.teacherId, workplanId: row.entity.workplanId, name: row.entity.teacherName}" action="row.entity.actionText"></panel-router-evaluation>'
        } 
      ],
      onRegisterApi: (gridApi) => {
        workplanEvaluationVM.gridApi = gridApi;
        workplanEvaluationVM.gridApi.grid.registerRowsProcessor(workplanEvaluationVM.singleFilter, 200);
        $interval(function () {
          workplanEvaluationVM.gridApi.core.handleWindowResize()
        }, 500, 10)
      }
    }

    workplanEvaluationVM.workPlanFilter = '';
    workplanEvaluationVM.isActiveDefaultGrid = false;
    workplanEvaluationVM.isActiveSpecialSituations = false;
    workplanEvaluationVM.isActiveEvaluated = false;
    workplanEvaluationVM.isActiveAdjustments = false;
    workplanEvaluationVM.isActiveForEvaluating = false;

    //indicator parameters
    workplanEvaluationVM.numberActualIndicator = '0';
    workplanEvaluationVM.numberTotalIndicator = '0';
    workplanEvaluationVM.numberPercentIndicator = '0';
    
    // Method definitions
    workplanEvaluationVM.filter = filter;    
    workplanEvaluationVM.activePlans = activePlans;
    workplanEvaluationVM.singleFilter = singleFilter;
    workplanEvaluationVM.exportGrid = exportGrid;
    
    // Initialization
    activate();

    function filter () {
      workplanEvaluationVM.gridApi.grid.refresh();
    }
    function activate () {
      workplanEvaluationVM.isActiveDefaultGrid = true;
      getListItems('default');
    }

    function getListItems (activeType) {
      var localHeader = {
        idRol: JSON.parse($cookies.get('hasRoleId')),
        idEvaluator: JSON.parse($cookies.get('currentUser')).id,
        idStage: stagesIds.evaluation,
        idIndicatorType: setTypeIndicator(activeType)
      }

      console.log(localHeader);

      ReviewSrv.getIndicatorsForWorkplanEvaluationByIndicator.post(localHeader).$promise.then((dataReturn) => {
        if (dataReturn.status === true) {
          console.log('indicador' + dataReturn.data);
          workplanEvaluationVM.numberPercentIndicator = dataReturn.data[0].nm_percentage; 
          workplanEvaluationVM.numberActualIndicator = dataReturn.data[0].nm_fraction;
          workplanEvaluationVM.numberTotalIndicator =  dataReturn.data[0].nm_total;
        } else {
          console.log('sin datos');
          console.log(dataReturn);
        }
      });

      //GET DATA FOR GRID
      switch (activeType) {
        case 'specialSituations': 
          ReviewSrv.getWorkplanForEvaluationByIndicator.post(localHeader).$promise.then((dataReturn) => {
            if (dataReturn.status === true) {
              workplanEvaluationVM.gridOptionsSpecialSituations.data = dataReturn.data;
            } else {
              console.log(dataReturn);
            }
          });
          break;
        case 'evaluated':
          ReviewSrv.getWorkplanForEvaluationByIndicator.post(localHeader).$promise.then((dataReturn) => {
            if (dataReturn.status === true) {
              workplanEvaluationVM.gridOptionsEvaluated.data = dataReturn.data;
            } else {
              console.log(dataReturn);
            }
          });
          break;
        case 'adjustments':
          ReviewSrv.getWorkplanForEvaluationByIndicator.post(localHeader).$promise.then((dataReturn) => {
            if (dataReturn.status === true) {
              workplanEvaluationVM.gridOptionsAdjustments.data = dataReturn.data;
            } else {
              console.log(dataReturn);
            }
          });
          break;
        case 'forEvaluating':
          ReviewSrv.getWorkplanForEvaluationByIndicator.post(localHeader).$promise.then((dataReturn) => {
            if (dataReturn.status === true) {
              workplanEvaluationVM.gridOptionsForEvaluating.data = dataReturn.data;
            } else {
              console.log(dataReturn);
            }
          });
          break;
        case 'default':
          ReviewSrv.getWorkplanForEvaluationByIndicator.post(localHeader).$promise.then((dataReturn) => {
            console.log('datos de plan default', dataReturn)
            if (dataReturn.status) {
              console.log('datos de plan default', dataReturn.data)
              workplanEvaluationVM.gridOptionsDefault.data = dataReturn.data;
              workplanEvaluationVM.gridApi.grid.refresh();
            }
          }).catch((err) => {
            console.log(err)
          })
          break;
      }

    }

       
    function setTypeIndicator(activeType){
       switch (activeType) {
        case 'specialSituations': 
          return evaluationIndicatorIds.specialSituations;
        case 'evaluated':
          return evaluationIndicatorIds.evaluated;
        case 'adjustments':
          return evaluationIndicatorIds.withAdjustments;
        case 'forEvaluating':
          return evaluationIndicatorIds.forEvaluating;
        default:
          console.log('no implementado');
          return 0;
      }

    }

    function activePlans(activeType){
      //console.log(activeType);

      workplanEvaluationVM.isActiveSpecialSituations = false;
      workplanEvaluationVM.isActiveEvaluated = false;
      workplanEvaluationVM.isActiveAdjustments = false;
      workplanEvaluationVM.isActiveForEvaluating = false;
      workplanEvaluationVM.isActiveDefaultGrid = false;

      switch (activeType) {
        case 'specialSituations':
          workplanEvaluationVM.isActiveSpecialSituations = true; break;
        case 'evaluated':
          workplanEvaluationVM.isActiveEvaluated = true; break;
        case 'adjustments':
          workplanEvaluationVM.isActiveAdjustments = true; break;
        case 'forEvaluating':
          workplanEvaluationVM.isActiveForEvaluating = true; break;
        default:
          workplanEvaluationVM.isActiveDefaultGrid = true; break;
          console.log('no implementado');
      }

      getListItems(activeType);
    }

    function singleFilter (renderableRows) {
      console.log('pasa por single filter');
      var matcher = new RegExp(workplanEvaluationVM.workPlanFilter,'i');
      renderableRows.forEach(function (row) 
      {
        var match = false;
        
        if(workplanEvaluationVM.isActiveSpecialSituations){
          [ 'teacherName', 'ds_description' ].forEach(function (field) {
            if (row.entity[field] && row.entity[field].match(matcher) ){
              match = true;
            }
          })
        }
        else if(workplanEvaluationVM.isActiveEvaluated){
          [ 'teacherName' ].forEach(function (field) {
            if (row.entity[field] && row.entity[field].match(matcher)) {
              match = true
            }
          })
        }
        else if(workplanEvaluationVM.isActiveAdjustments){
          [ 'teacherName' ].forEach(function (field) {
            if (row.entity[field] && row.entity[field].match(matcher)) {
              match = true
            }
          })
        }
        else if(workplanEvaluationVM.isActiveForEvaluating){
          [ 'teacherName' ].forEach(function (field) {
            if (row.entity[field] && row.entity[field].match(matcher)) {
              match = true
            }
          })
        }
        else if(workplanEvaluationVM.isActiveDefaultGrid){
          [ 'teacherName' ].forEach(function (field) {
            if (row.entity[field] && row.entity[field].match(matcher)) {
              match = true
            }
          })
        }
        if (!match) {
          row.visible = false
        }
      })
      return renderableRows
    }

    function exportGrid(activeType) {
      var myElement =  angular.element(document.querySelectorAll("."+ activeType +"-export"));
      //console.log(myElement);
      workplanEvaluationVM.gridApi.exporter.csvExport(
        uiGridExporterConstants.VISIBLE, uiGridExporterConstants.VISIBLE, myElement);
    }
  }
}

WorkplanEvaluationCtrl.$inject = ['$scope', '$stateParams', '$timeout', 'WorkPlanSrv', 'WorkPlanModalSrv', 'GlobalConfig', '$cookies', '$state', 'ReviewSrv', '$rootScope', 'uiGridConstants','uiGridExporterConstants', '$interval', '$mdDialog']



// WEBPACK FOOTER //
// ./src/app/u-faculty/workplan/start/evaluation/workplanEvaluationCtrl.js